<template>
  <portal to="modal-destination">
    <Moveable
      class="moveable"
      v-bind="moveable"
      @drag="onDrag"
      @dragStart="onDragStart"
      @dragEnd="onDragEnd"
      @resize="onResize"
      @resizeStart="onResizeStart"
      @resizeEnd="onResizeEnd"
      target="#modal-video-helper-center"
    />

    <div class="modal-video-helper-center" id="modal-video-helper-center" ref="modalRef">
      <button @click="$emit('hideModal')" class="modal-close">
        <i class="fas fa-times fa-fw"></i>
      </button>

      <div class="loading">
        <aha-spinner variant="white" />
      </div>

      <iframe
        ref="iframeRef"
        id="video-tutorial-iframe"
        class="w-full h-full object-cover"
        :src="`${youtubeLink}?autoplay=1&rel=0`"
        title="YouTube video player"
        frameborder="0"
        allow="
          accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture
        "
        allowfullscreen
      />
    </div>
  </portal>
</template>

<script>
import Moveable from 'vue-moveable'
import utils from '@/util'
import constants from '@/constant'

export default {
  name: 'VideoTutorialModal',
  components: {
    Moveable,
  },
  props: {
    youtubeLink: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    moveable: {
      draggable: true,
      throttleDrag: 1,
      resizable: true,
      throttleResize: 1,
      keepRatio: true,
      scalable: false,
      throttleScale: 0.01,
      rotatable: false,
      throttleRotate: 0.2,
      pinchable: false,
      origin: false,
    },
  }),
  mounted() {
    this.$nextTick(function _() {
      const rightColumnEl = document.querySelector('.right-presentation')

      if (rightColumnEl && this.$refs.modalRef) {
        this.$refs.modalRef.style.transform = `translate(
          calc(100vw - ${rightColumnEl.offsetWidth + this.$refs.modalRef.offsetWidth + 25}px),
          calc(100vh - ${this.$refs.modalRef.offsetHeight + 26}px)
        )`

        const { x, y } = this.$refs.modalRef.getBoundingClientRect()
        this.$refs.modalRef.style.transform = `translate(${x}px, ${y}px)`
      }
    })
  },
  methods: {
    onDrag({ target, transform }) {
      target.style.transform = transform
    },
    onDragStart() {
      this.$refs.iframeRef.style.pointerEvents = 'none'
    },
    onDragEnd({ isDrag }) {
      this.$refs.iframeRef.style.pointerEvents = 'auto'

      if (isDrag) {
        utils.mixpanelTracking(
          constants.eventCategories.PRESENTATION_EDITOR,
          'Video tutorial > Drag video',
          this.$store.state.slideActive.type,
        )
      }
    },
    onResize({
      target, width, height, drag,
    }) {
      target.style.width = `${width}px`
      target.style.height = `${height}px`
      target.style.transform = `${drag.transform}`
    },
    onResizeStart() {
      this.$refs.iframeRef.style.pointerEvents = 'none'
      this.$refs.modalRef.classList.add('resizing')
    },
    onResizeEnd() {
      this.$refs.iframeRef.style.pointerEvents = 'auto'
      this.$refs.modalRef.classList.remove('resizing')
    },
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/variable.scss";

.modal-video-helper-center {
  position: fixed;
  z-index: 9;
  filter: drop-shadow(0px 14px 46px rgba(0, 0, 0, 0.1));
  padding: 38px 7px 7px 7px;
  border-radius: 4px;
  cursor: all-scroll;
  width: 649px;

  &.resizing {
    background-color: #fff;
  }

  &:hover {
    background-color: #fff;

    .modal-close {
      visibility: visible;
    }
  }

  .modal-close {
    visibility: hidden;
    padding: 12px;
    position: absolute;
    right: 0;
    top: 0;
    background-color: transparent;
    color: #AFAFAF;
    font-size: 13px;

    &:focus {
      border: none;
      outline: 0;
    }

    &:hover {
      color: #191F2D;
    }
  }

  .loading {
    position: absolute;
    top: 38px;
    right: 7px;
    bottom: 7px;
    left: 7px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: -1;
    background-color: #4b4b4b;
  }

  iframe {
    width: 100%;
    height: 100%;
    aspect-ratio: 16 / 9;
  }
}

#modal-destination {
  .moveable-control-box {
    opacity: 0;

    &:hover ~ .modal-video-helper-center {
      background-color: #fff;
    }

    .moveable-control {
      width: 24px;
      height: 24px;
      margin-top: -12px;
      margin-left: -12px;
    }
  }
}
</style>
